import "components/global-styles/index.css";
import { ApplicationContextProvider } from "contexts/ApplicationContext";
import { NotificationContextProvider } from "contexts/notification-context";
import "styles/imports.scss";
import "components/slider/style.css";
import { getFavIcon, getTitle } from "components/white-label";

import NotFound from "pages/not-found/page";
import { useEffect } from "react";
import { RouterSelect } from "router-manager/parts/router-select";

const App = () => {
  document.title = getTitle();

  useEffect(() => {
    getFavIcon();
  }, []);

  return (
    <ApplicationContextProvider>
      <NotificationContextProvider>
        <RouterSelect notFoundPage={NotFound} redirectIfNotLogged="/login" />
      </NotificationContextProvider>
    </ApplicationContextProvider>
  );
};

export default App;
